import { LoadingButton } from "@mui/lab";
import { Box, Link, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Password from "src/components/Password";
import ChoosePlan from "src/components/choose-plan";
import {
  FormProvider,
  RHFCheckbox,
  RHFTextField,
} from "src/components/hook-form";
import Translate from "src/components/translate";
import { PATH_AUTH } from "src/routes/paths";
import AuthHelper from "./components/authHelper";
import EnterOtp from "./components/enter-otp";
import ErrorBanner from "./components/error-banner";
import useLogin from "./hooks/use-login";
import { CAPTCHA_SITE_KEY } from "src/config";
import ReCAPTCHA from "react-google-recaptcha";
import { useEffect, useRef, useState } from "react";
import useIsDarkMode from "src/hooks/use-is-darkmode";

const LoginForm = () => {
  const { onSubmit, methods } = useLogin();
  const recaptcha = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(null);
  const isDark = useIsDarkMode();

  const {
    watch,
    formState: { isSubmitting },
  } = methods;

  const data = watch();

  const username = watch("email");
  useEffect(() => {
    if (username) {
      methods.setValue("email", username.toUpperCase());
    }
  }, [username]);

  return (
    <>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack spacing={2} mb={2}>
          <AuthHelper />
          <ErrorBanner />
        </Stack>

        <Box>
          <Stack spacing={2}>
            <RHFTextField name="email" label="Username" />
            <Password name="password" label="register.password" />
            <ChoosePlan />
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ my: 2 }}>
            <RHFCheckbox name="remember" label="register.remember" />
            <Link
              component={RouterLink}
              variant="subtitle2"
              sx={{
                color: "GrayText",
              }}
              to={PATH_AUTH.resetPassword}>
              <Translate>register.forgot</Translate>
            </Link>
          </Stack>
          <ReCAPTCHA
            sitekey={CAPTCHA_SITE_KEY}
            ref={recaptcha}
            theme={isDark ? "dark" : "light"}
            onChange={(value) => setCaptchaValue(value)}
          />
          <LoadingButton
            sx={{ mt: 2 }}
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            disabled={!captchaValue}
            loading={isSubmitting}
            name="login">
            <Translate>register.login</Translate>
          </LoadingButton>
        </Box>
      </FormProvider>

      <EnterOtp data={data} />
    </>
  );
};

export default LoginForm;
